import { http } from '../http';

export interface TipoVeiculo {
  codigo_tipo: string;
  descricao_tipo: string;
  cota_fipe_cilindrada: string;
  participacao_minima: string;
  porcentagem_fipe: string;
  situacao: string;
}

export interface TipoVeiculoResponse {
  total: number;
  page: number;
  limit: number;
  items: TipoVeiculo[];
}

/**
 * @param comPlano true = só os tipos que têm PLANO DE COTAÇÃO ativo, na ordem
 * definida na tabela `plano_cotacao` (item 6). Usado pela tela de cotação, cujo
 * tipo escolhido vira o `codigoPlano` do PDF — tipo sem plano ali dá 400.
 * Omitido = lista histórica, usada pelas telas de carro (onde o tipo define
 * cota/produtos do veículo e não tem relação com o conteúdo do PDF).
 */
export const fetchSgaTipoVeiculos = async (
  page: number = 1,
  limit: number = 10,
  comPlano: boolean = false
): Promise<TipoVeiculoResponse> => {
  const response = await http.get('/sga-tipo-veiculo/listar', {
    params: comPlano ? { page, limit, comPlano: true } : { page, limit },
  });

  return response.data;
};

/**
 * Sincroniza o espelho de tipos de veículo com o SGA (TI/ADMIN, at-44).
 * O cron diário das 6h10 faz o mesmo sozinho — o disparo manual só antecipa.
 */
export const sincronizarSgaTipoVeiculos = async (): Promise<{
  sincronizadas: number;
  inativadas: number;
}> => {
  const { data } = await http.get('/sga-tipo-veiculo/sync');
  return data;
};
